import React from "react";
import { twJoin } from "tailwind-merge";

export const LoadingDots: React.FC = () => {
  return (
    <div className="flex justify-center items-center mb-2">
      <div
        className={twJoin(
          "dot-flashing relative h-[6px] w-[6px] rounded-full bg-black text-black",
          'before:absolute before:-left-3 before:top-0 before:inline-block before:h-[6px] before:w-[6px] before:rounded-full before:bg-black before:text-black before:content-[""]',
          'after:absolute after:left-3 after:top-0 after:inline-block after:h-[6px] after:w-[6px] after:rounded-full after:bg-black after:text-black after:content-[""]',
        )}
      />
    </div>
  );
};

const Loading: React.FC<{ message: string }> = ({ message }) => {
  return (
    <div className="flex flex-col justify-center items-center mx-5 max-w-screen-xl md:mx-11 lg:mx-24 xl:mx-auto grow-fade-in min-h-[218px] lg:min-h-[236px]">
      <LoadingDots />
      <div className="mt-2 text-xs text-center text-black/70">{message}</div>
    </div>
  );
};

export default Loading;
